import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigBreadcrumbComponent } from './config-breadcrumb.component';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigSearchComponent } from './config-search/config-search.component';
import { ConfigSearchDetailComponent } from './config-search/config-search-detail.component';
import { ConfigSearchService } from './config-search/config-search.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot(),
  ],
  declarations: [
    ConfigBreadcrumbComponent,
    ConfigSearchComponent,
    ConfigSearchDetailComponent
  ],
  exports: [
    ConfigBreadcrumbComponent,
    ConfigSearchComponent,
    ConfigSearchDetailComponent
  ],
  providers:[ConfigSearchService]
})
export class ConfigBreadcrumbModule { }
